export function handle_drop(state, e) {
    state.isDragging = false;

    const files = e?.dataTransfer?.files;
    if (!files || files.length === 0) return;

    const mockEvent = {
        target: { files }
    };

    handle_file_upload(mockEvent, state);
}


export function handle_file_upload(event, state) {
    const files = Array.from(event?.target?.files || []);
    if (!files.length) return;

    state.fileError = null;

    const MAX_FILES = 10;

    if (files.length + state.upload_files.length > MAX_FILES) {
        state.fileError = `Maximum ${MAX_FILES} files allowed.`;
        return;
    }

    files.forEach(file => {
        state.upload_files.push(file);

        // IMAGE
        if (file.type.startsWith("image/")) {
            const reader = new FileReader();

            reader.onload = (e) => {
                state.previews.push({
                    type: "image",
                    src: e.target.result,
                    name: file.name
                });
            };

            reader.readAsDataURL(file);
        }

        // VIDEO
        else if (file.type.startsWith("video/")) {
            const url = URL.createObjectURL(file);

            state.previews.push({
                type: "video",
                src: url,
                name: file.name
            });
        }

        // FILE
        else {
            state.previews.push({
                type: "file",
                name: file.name,
                extension: file.name.split('.').pop().toLowerCase()
            });
        }
    });

    event.target.value = "";
}

export function get_single_file_from_event(event) {
    return event?.target?.files?.[0] || null;
}

export function clear_file_input(event) {
    if (event?.target) {
        event.target.value = "";
    }
}

export function handle_typed_file_upload(event, { accepted_type, invalid_message }) {
    const file = get_single_file_from_event(event);

    if (!file) {
        return {
            file: null,
            file_name: "",
            error: ""
        };
    }

    if (accepted_type && !file.type.startsWith(accepted_type)) {
        clear_file_input(event);

        return {
            file: null,
            file_name: "",
            error: invalid_message || "Invalid file type."
        };
    }

    return {
        file,
        file_name: file.name,
        error: ""
    };
}

export function handle_audio_upload(event) {
    return handle_typed_file_upload(event, {
        accepted_type: "audio/",
        invalid_message: "Only audio files are allowed."
    });
}

export function build_home_left_nav_items(context) {
    return [
        {
            show: true,
            label: 'News Feed',
            icon: 'bi-house-fill',
            active: context.activeTab === 'normal_loans_info',
            event: 'feed'
        },
        {
            show: true,
            label: 'Notifications',
            icon: 'bi-envelope-fill',
            badge: context.notification_count,
            event: 'notifications'
        },
        {
            show: context.client_features?.show_personal_profile,
            label: 'Friends',
            icon: 'bi-people-fill',
            badge: context.following_count,
            href: '/view_personal_profiles'
        },
        {
            show: context.client_features?.show_upcoming_birthdays,
            label: 'Upcoming Birthdays',
            icon: 'bi-gift-fill',
            badge: context.upcoming_birthday_count,
            href: '/view_all_birthdays'
        },
        {
            show: context.can_create_business_profile,
            label: 'Create Business Profile',
            icon: 'bi-building-add',
            event: 'create-business-profile'
        },
        {
            show: context.client_features?.show_your_voice,
            label: 'Your Voice',
            icon: 'bi-megaphone-fill',
            active: context.activeTab === 'top_loans_info',
            event: 'voice'
        },
        { show: true, label: 'Settings', icon: 'bi-gear-fill', event: 'settings' },
    ];
}

function slugify_profile_value(value) {
    return String(value || "")
        .trim()
        .toLowerCase()
        .replace(/&/g, " and ")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
}

function get_profile_base(profile) {
    return profile?.id;
}

function get_profile_name(profile) {
    return [
        profile?.company_name,
        profile?.profile_name,
        get_person_name(profile),
        get_person_name(profile?.user),
    ].find(Boolean) || "profile";
}

function get_person_name(profile) {
    return [profile?.first_name, profile?.last_name].filter(Boolean).join(" ");
}

function get_profile_type(profile) {
    const profile_type_name = get_profile_type_name(profile);
    if (profile_type_is_known(profile_type_name)) return profile_type_name;

    return profile_has_business_fields(profile) ? "business" : "personal";
}

function get_profile_type_name(profile) {
    const profile_type = [
        profile?.profile_type,
        profile?.base_profile?.profile_type,
        profile?.company?.base_profile?.profile_type,
    ].find(Boolean);
    return String(profile_type?.profile_type || profile_type?.name || profile_type || "").toLowerCase();
}

function profile_type_is_known(profile_type_name) {
    return ["business", "personal"].includes(profile_type_name);
}

function profile_has_business_fields(profile) {
    return [
        profile?.company,
        profile?.company_id,
        profile?.company_name,
        profile?.base_profile?.company,
    ].some(Boolean);
}

function get_profile_user_id(profile) {
    return  profile?.user?.id;
}

export function get_profile_url(profile) {
    const user_id = get_profile_user_id(profile);
    const profile_type = get_profile_type(profile);
    const is_business = profile_type === "business";
    const type = is_business ? "business" : "personal";
    const id = is_business ? get_profile_base(profile) : user_id;
    const slug = slugify_profile_value(get_profile_name(profile));

    return id ? `/profile/${type}/${slug}-${id}` : "";
}

export function view_profile(_router, profile) {
    const profile_url = get_profile_url(profile);

    if (profile_url) {
        if (_router?.push) {
            _router.push(profile_url);
            return;
        }

        window.location = profile_url;
    }
}
